import EventEmitter from 'events'
import { createContext, ReactNode, useContext } from 'react'

const EECtx = createContext<EventEmitter>(null)

export function EventEmitterProvider({
  children,
  eventEmitter,
}: {
  children: ReactNode
  eventEmitter: EventEmitter
}) {
  return <EECtx.Provider value={eventEmitter}>{children}</EECtx.Provider>
}

export function useEventEmitter() {
  return useContext(EECtx)
}
